import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../Buttons/button.css";
import "../Schedule/schedule.css";
import PDF from "../../../Docs/23-Schedule-Flat-RF-PRESS.pdf";
import Mid from "../../../images/Mid.png";
import Iowa from "../../../images/Iowa.png";
import Pocono from "../../../images/Pocono.png";
import Michigan from "../../../images/Michigan.png";
import Indy from "../../../images/Indy.png";
import Watkins from "../../../images/Watkins.png";
import Illinois from "../../../images/Illinois.png";
import Milwaukee from "../../../images/Milwaukee.png";
import DuQuoin from "../../../images/DuQuoin.png";
import Kansas from "../../../images/kansas-speedway.png";
import Bristol from "../../../images/Bristol.png";
import Salem from "../../../images/Salem.png";
import Toledo from "../../../images/Toledo.png";

const ScheduleII = () => {
  const [logo, setLogo] = useState("");

  useEffect(() => {
    const getLogoByLatestDate = () => {
      const currentDate = new Date();

      const dates = [
        { date: "2023-06-25", logo: Mid },
        { date: "2023-07-08", logo: Iowa },
        { date: "2023-07-16", logo: Pocono },
        { date: "2023-07-22", logo: Michigan },
        { date: "2023-08-05", logo: Indy },
        { date: "2023-08-12", logo: Watkins },
        { date: "2023-08-19", logo: Illinois },
        { date: "2023-08-21", logo: Milwaukee },
        { date: "2023-08-28", logo: DuQuoin },
        { date: "2023-09-04", logo: Kansas },
        { date: "2023-09-09", logo: Bristol },
        { date: "2023-09-15", logo: Salem },
        { date: "2023-10-01", logo: Toledo },
      ];

      const latestPassedDate = dates
        .filter((entry) => new Date(entry.date) <= currentDate)
        .pop();

      if (latestPassedDate) {
        setLogo(latestPassedDate.logo);
      }
    };

    getLogoByLatestDate();
  }, []);

  return (
    <Container className="mb-2" fluid>
      <Row className="text-start">
        <Col md={6} className="bg-black-schedule">
          <h3>RACE SCHEDULE</h3>
          <hr />
          <br />
          <Row className="mt-3">
            <Col md={8}>
              <h5 className="fw-bolder text-left mb-0">
                DU QUOIN STATE FAIRGROUNDS
              </h5>
              <p className="text-left mt-0">Du Quoin, IL</p>
            </Col>
            <Col md={4}>
              <h5>SEPTEMBER 3RD, 2023</h5>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={8}>
              <h5 className="fw-bolder text-left mb-0">KANSAS SPEEDWAY</h5>
              <p className="text-left mt-0">Kansas City, KS</p>
            </Col>
            <Col md={4}>
              <h5>SEPTEMBER 8TH 2023</h5>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={8}>
              <h5 className="fw-bolder text-left mb-0">
                BRISTOL MOTOR SPEEDWAY
              </h5>
              <p className="text-left mt-0">Bristol, TN</p>
            </Col>
            <Col md={4}>
              <h5>SEPTEMBER 14TH, 2023</h5>
            </Col>
          </Row>
          <Row>
            <Col>
              <a href={PDF} target="_blank" rel="noreferrer">
                <button className="btn2">Full Schedule</button>
              </a>
            </Col>
          </Row>
        </Col>
        <Col md={6} className="bg-white-pad">
          <h3 className="red">NEXT RACE</h3>
          <hr className="red" />
          <img src={logo} alt="Logo" />
        </Col>
      </Row>
    </Container>
  );
};

export default ScheduleII;
